import { Injectable } from '@angular/core';
import { RestResponse } from 'app/modules/common/entities/rest.response.model';
import { ApiService } from 'app/modules/common/services/api.service';
import { Observable } from 'rxjs';
import API from '../../common/services/api.config.json';
import { VisitaEmpresaSaveModel } from '../entities/visita-empresa';

@Injectable({
  providedIn: 'root'
})
export class CoordinatorCompanyService {

  constructor(private apiService: ApiService) { }

  public GetCompanyList(selectedDate: string): Observable<RestResponse> {
    const url = `${API.Coordinator.getCoordinatorCompanyList}`;
    return this.apiService.post(url, {selectedDate});
  }

  public GetVisitaEmpresa(year: string): Observable<RestResponse> {
    let url = `${API.Coordinator.getCoordinatorVisitaEmpresa}`;
    url = url.replace('{year}', year);
    return this.apiService.get(url);
  }

  public GetVisitaEmpresaDetails(id: string): Observable<RestResponse> {
    let url = `${API.Coordinator.getVisitaEmpresa}`;
    url = url.replace('{id}', id);
    return this.apiService.get(url);
  }

  public AddEditVisitaEmpresa(visitaEmpresa: VisitaEmpresaSaveModel): Observable<RestResponse> {
    const url = `${API.Coordinator.addEditVisitaEmpresa}`;
    return this.apiService.post(url, visitaEmpresa);
  }

  public DeleteVisitaEmpresa(id: string): Observable<RestResponse> {
    let url = `${API.Coordinator.deleteVisitaEmpresa}`;
    url = url.replace('{id}', id);
    return this.apiService.delete(url);
  }
  public GetPersonalContacto(empresaId: string): Observable<RestResponse> {
    let url = `${API.Coordinator.getPersonalContacto}`;
    url = url.replace('{EmpresaID}', empresaId);
    return this.apiService.get(url);
  }
}
